import { HOMEWORK_STATUS } from '../values/homeworks.values';

export class RequestCreateHomework {
  id: number;
  sectionId?: number;
  classId: number;
  name: string;
  description: string;
  type: string;
  text: string;
  grade: number;
  grades: any;
  status: HOMEWORK_STATUS;
  answers?: string[];
  usersAnnotations?: number[]
  constructor(data: any) {
    this.id = data.id;
    this.sectionId = data.sectionId;
    this.classId = data.classId;
    this.name = data.name;
    this.description = data.description;
    this.type = data.type;
    this.text = data.text;
    this.grade = data.grade;
    this.grades = data.grades;
    this.status = data.status;
    this.answers = data.answers;
    this.usersAnnotations = data.usersAnnotations;
  }
}